import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IssueResponseDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type Params = {
  issueCode: string;
};

export function useDeleteAttachment({ issueCode }: Params) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<IssueResponseDto, ExtendedAxiosError, { id: string }>({
    mutationKey: ['attachments'],
    mutationFn: ({ id }) =>
      api.attachmentsApi.deleteAttachment(id).then((r) => r.data),
    onSuccess: (response) => {
      queryClient.setQueryData<IssueResponseDto>(
        ['issues', issueCode],
        response,
      );
    },
  });
}
